(() => {
  'use strict';
  if (window.AldenProductEngineLoader?.promise) return;
  const config = window.AldenProductEngineAssets || {};
  const order = ['core','state','ui','price','availability','variantAvailability','gallery','atc','stickyAtc','featuredTabs','history','regression','diagnostics','debugOverlay'];
  const loadScript = (key) => new Promise((resolve, reject) => {
    const src = config[key];
    if (!src) { resolve(); return; }
    const existing = Array.from(document.scripts).find((script) => script.src === src);
    if (existing) {
      if (existing.dataset.aldenLoaded === 'true') { resolve(); return; }
      existing.addEventListener('load', resolve, { once:true });
      existing.addEventListener('error', reject, { once:true });
      return;
    }
    const script = document.createElement('script');
    script.src = src;
    script.async = false;
    script.dataset.aldenEngineAsset = key;
    script.addEventListener('load', () => { script.dataset.aldenLoaded = 'true'; resolve(); }, { once:true });
    script.addEventListener('error', () => reject(new Error(`Failed to load ${key}: ${src}`)), { once:true });
    document.head.appendChild(script);
  });
  const promise = Promise.all(order.map(loadScript)).then(() => {
    document.dispatchEvent(new CustomEvent('alden:product-engine-ready'));
    return window.AldenProductEngine || null;
  }).catch((error) => { console.error('[AldenProductEngineLoader]', error); throw error; });
  window.AldenProductEngineLoader = Object.freeze({ version:2, promise, assets:Object.freeze({ ...config }) });
})();